import React from "react";
import Language from "../lib/Language";
import { useAppContext } from "../contexts/AppContext";
import { TComponent } from "../types/utils";

const TARGET = "_blank";

const openAdminUI = (event: React.MouseEvent) => {
    window.open(window.location.href.replace("/client", "/admin"), TARGET);
    event.preventDefault();
};

const AdminPane: TComponent = () => {
    const appContext = useAppContext();

    const renderAdminLinks = () => {
        if (appContext.user?.isAdmin) {
            return [
                <p key="desc">{Language.get("nc_admin_link_description")}</p>,
                <form key="adminForm">
                    <ul key="link">
                        <li key="1" className="btnGroup">
                            <button className="deprecated default" onClick={openAdminUI}>
                                {Language.get("admin_main_menu_title")}{" "}
                                <div className="whiteArrow" />
                            </button>
                        </li>
                    </ul>
                </form>,
            ];
        }
        return null;
    };

    return (
        <div className="adminPane">
            <h2>{Language.get("user_permission_admin")}</h2>
            {renderAdminLinks()}
        </div>
    );
};

export default AdminPane;
